import React from 'react';

import {Box} from 'src/components/shared';
import styled from 'styled-components/macro';

type ResponsiveAspectRatios = '16:9' | '4:3' | '3:2' | '8:5';

export const ResponsiveContentWrapper: React.FC<{aspectRatio: ResponsiveAspectRatios}> = ({aspectRatio, children}) => (
  <Container aspectRatio={aspectRatio}>
    <Content>{children}</Content>
  </Container>
);

const AspectRatioToPaddingMap: Record<ResponsiveAspectRatios, number> = {
  '16:9': 55.5,
  '4:3': 75,
  '3:2': 66.66,
  '8:5': 62.5,
};

const Container = styled(Box)<{aspectRatio: ResponsiveAspectRatios}>`
  position: relative;
  overflow: hidden;
  padding-top: ${({aspectRatio}) => AspectRatioToPaddingMap[aspectRatio]}%;
`;

const Content = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;

  > iframe {
    border: 0;
  }
`;
